import { __decorate } from "tslib";
import { AutoEncoder, DateDecoder, StringDecoder, field } from '@common/encoding';
export class SetupStepReview extends AutoEncoder {
    date;
    userName;
    userId;
    getDiffValue() {
        return this.userName;
    }
}
__decorate([
    field({ decoder: DateDecoder })
], SetupStepReview.prototype, "date", void 0);
__decorate([
    field({ decoder: StringDecoder })
], SetupStepReview.prototype, "userName", void 0);
__decorate([
    field({ decoder: StringDecoder })
], SetupStepReview.prototype, "userId", void 0);
//# sourceMappingURL=SetupStepReview.js.map